/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as MapHelper from 'shared-ui/maps/helpers/mapHelper';

const makeGeoJsonPoint = ({
    id = 0,
    longitude = -96,
    latitude = 39,
    type = 'facility',
    symbol = 'rec-icon-ticket',
    asset,
}) => {
    const geoJsonPoint = {
        geometry: {
            coordinates: [longitude, latitude],
            type: 'Point',
        },
        properties: {
            id,
            type,
            symbol,
            asset,
        },
        type: 'Feature',
    };
    return geoJsonPoint;
};

export const makeGeoJsonData = (facilityData, tourData, tourPinsFlag) => {
    if (tourPinsFlag && Array.isArray(tourData) && tourData.length) {
        return tourData.map((tour) => {
            return makeGeoJsonPoint({
                id: tour.tour_id,
                longitude: tour.tour_longitude,
                latitude: tour.tour_latitude,
                type: 'tour',
                asset: {
                    imageUrl: tour.image_url,
                    imageTitle: 'Tour Preview Image',
                    title: tour.tour_name,
                    targetUri: MapHelper.getTargetUri({
                        entity_type: 'timedentry_tour',
                        parent_id: facilityData.id,
                        entity_id: tour.tour_id,
                    }),
                },
            });
        });
    }
    return [makeGeoJsonPoint(facilityData)];
};
